import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout8({ data, files }: LayoutProps) {
 return (
  <div className="container">
   <div className="flex flex-wrap">
    <div
     className="w-full pt-2.5 sm:w-full md:w-2/3 lg:w-2/3"
     data-aos="fade-left"
    >
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[0].src}
     />
    </div>
    <div
     className="w-full pt-2.5 sm:w-full md:w-1/3 lg:w-1/3"
     data-aos="fade-right"
    >
     <CaseVideo
      videoIndex={0}
      add="embed-responsive spa"
      video={files[1].src}
     />
    </div>
   </div>
   <div className="flex flex-wrap">
    <div className="w-full pt-2.5" data-aos="fade-left">
     <CaseImage
      imageIndex={0}
      folder={data.cf_client_name}
      image={files[2].src}
     />
    </div>
   </div>
  </div>
 )
}
